import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

// AG Grid 모듈 등록
ModuleRegistry.registerModules([AllCommunityModule]);

import router from "./router";
import { markUpdateAvailable } from "./utils/appUpdate";

// Vite 가 동적 import(preload) 실패 시 쏘는 이벤트 — 배포로 청크가 사라진 경우. 새로고침 토스트 노출.
window.addEventListener("vite:preloadError", () => markUpdateAvailable());

createApp(App).use(router).mount("#app");
